export const ARVUT_URL = "https://arvut.kli.one";
export const EVENTS_API_URL = "https://events.kli.one/api/events";

// Variables to toggle components
export const CHAT_AND_NOTIFICATION_ICONS =
    process.env.NODE_ENV === "development" ? false : false;
export const SEARCH_BAR =
  process.env.NODE_ENV === "development" ? false : false;

